module.exports = __webpack_public_path__ + "img/02.85e6abd6.jpg";